package team.platforma.multiplatform_material_extension.ui.flexbox

data class InputChipItem(
    val id: Long,
    val title: String,
    val enabled: Boolean
)
